import { selectedCompanyIdAtom } from 'atoms';

// Global reference to the Jotai store
let jotaiStore: any = null;

// Function to set the Jotai store reference
export const setJotaiStore = (store: any) => {
  jotaiStore = store;
};

// Function to set the selected company ID atom from outside React
export const setSelectedCompanyIdAtom = (companyId: string | null) => {
  if (jotaiStore) {
    jotaiStore.set(selectedCompanyIdAtom, companyId);
  }
};
